import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthHTTPService } from 'src/app/modules/auth/_services/auth-http';
import { HotToastService } from '@ngneat/hot-toast';
import { ConfirmPasswordValidator } from './confirm-password.validator';
import { AuthService } from 'src/app/modules/auth';
import { Observable, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit, OnDestroy {
  language: any;
  hasError: boolean;
  ErrorMessage: string;
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  forgetPasswordForm: UntypedFormGroup;
  isLoading$: Observable<boolean>;
  @Input() PatientId: any;
  @Input() PassportNo: any;

  @Input() SecretKey : any;
  @Input() GuestId: any;
  ResetPassword:boolean = false;
  ValidateOtp:boolean = true;
  @Input() OtpCode:string;
  constructor(private translationService: TranslationService, private authService: AuthService,
     private toast: HotToastService,
    public modal: NgbActiveModal, private fb: UntypedFormBuilder,) { this.isLoading$ = this.authService.isLoading$; }
  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.initForm();
  }
  onNoClick(): void {
    this.modal.close();
  }
  get ForgetPasswordForm() {
    return this.forgetPasswordForm.controls;
  }
  initForm() {
    this.forgetPasswordForm = this.fb.group({
      NewPassword: ['', [Validators.required,Validators.minLength(6),Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.{6,})/)]],
      ConfirmPassword: ['', Validators.required],
    }, {
      validator: ConfirmPasswordValidator.MatchPassword,
    });
  }
  submit() {
    this.forgetPasswordForm.markAllAsTouched();
    if (!this.forgetPasswordForm.valid) {
      return;
    }
    this.authService.showLoader();
    const Subscr = this.authService.ResetPassword(this.PatientId,this.GuestId,this.ForgetPasswordForm.ConfirmPassword.value,this.SecretKey).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {
      
      if (res.isSuccess && res.responseCode == 200) {
        this.toast.success("<b>" + res.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
        this.onNoClick();

      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();

      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();

      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "رقم الهوية أو كلمة المرور غير صحيحة";
        }
        else {
          this.ErrorMessage = "National ID / Iqama or Password is incorrect";
        }
        this.authService.hideLoader();

      }
    });
    this.unsubscribe.push(Subscr);
  }
  ValidateOtpCode() {
    
    if (!this.OtpCode || this.OtpCode == null || this.OtpCode == '') {
      if (this.language == 'ar')
      {
        this.toast.warning("<b>ادخل الرمز المكون من 6 ارقام اولا ، من فضلك</b>", { style: { padding: '20px' } });

      }
      else
      {
        this.toast.warning("<b>Enter the 6-digit code, please</b>", { style: { padding: '20px' } });

      }
      return;
    }
    this.authService.showLoader();
    // var UserId = this.PatientId;
    // if (this.PatientId == null || this.PatientId == 0)
    // {
    //   UserId = this.GuestId;
    // }
    const Subscr = this.authService.ValidateOtp(this.PassportNo,this.OtpCode, this.SecretKey).pipe(
      catchError((errorMessage) => {
        return of(errorMessage);
      })
    ).subscribe(res => {
      
      if (res.isSuccess && res.responseCode == 200) {
        this.ValidateOtp = false;
        this.ResetPassword = true;
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 404) {
        this.toast.warning("<b>" + res.error?.message + "</b>", { style: { padding: '20px' } });
        this.authService.hideLoader();
      }
      else if (!res.error?.isSuccess && res.error?.responseCode == 500) {
        if (this.language == "ar") {
          this.toast.warning("<b>حدث خطأ ما ، من فضلك ، حاول مرة أخرى لاحقًا</b>", { style: { padding: '20px' } });
        }
        else {
          this.toast.warning("<b>Something went wrong, try again later, please</b>", { style: { padding: '20px' } });
        }
        this.authService.hideLoader();
      }
      else {
        if (this.language == "ar") {
          this.ErrorMessage = "رقم الهوية أو كلمة المرور غير صحيحة";
        }
        else {
          this.ErrorMessage = "National ID / Iqama or Password is incorrect";
        }
        this.authService.hideLoader();
      }
    });
    this.unsubscribe.push(Subscr);
  }
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.forgetPasswordForm.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.forgetPasswordForm.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  controlHasError(validation: string, controlName: string) {
    const control = this.forgetPasswordForm.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }
  isControlTouched(controlName: string): boolean {
    const control = this.forgetPasswordForm.controls[controlName];
    return control.dirty || control.touched;
  }
}
